import {useQuery} from "@tanstack/react-query";

import {DateString} from "@globals/types/utilityTypes";

import {getSubsidyInfo} from "../DailyMenuService";
import {DaySubsidyInfoData} from "../interfaces";

export default function useDaySubsidyInfo(selectedDate?: DateString): {
  daySubsidyInfo?: DaySubsidyInfoData;
  isError: boolean;
} {
  const {data, isError} = useQuery<DaySubsidyInfoData, Error>({
    queryKey: ["getSubsidyInfo", selectedDate],
    queryFn: () => getSubsidyInfo(selectedDate as DateString),
    enabled: Boolean(selectedDate),
  });

  return {
    daySubsidyInfo: data,
    isError,
  };
}
